export const ENTERPRISE_INVOICE_PRODUCT_NAMES = [
  '技术开发费',
  '技术服务费',
  '信息技术服务费',
  '研发服务费',
  '推广费',
  '运营费'
]

export const DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES = ['技术服务费']

export function normalizeProductNames(value) {
  const selected = Array.isArray(value) ? value : []
  const allowed = new Set(ENTERPRISE_INVOICE_PRODUCT_NAMES)
  const unique = new Set(
    selected
      .map(item => String(item || '').trim())
      .filter(item => allowed.has(item))
  )
  const ordered = ENTERPRISE_INVOICE_PRODUCT_NAMES.filter(item => unique.has(item))
  return ordered.length > 0 ? ordered : [...DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES]
}

export function hasProductNames(value) {
  return Array.isArray(value) && value.some(item => ENTERPRISE_INVOICE_PRODUCT_NAMES.includes(String(item || '').trim()))
}

export function formatProductNames(value) {
  return normalizeProductNames(value).join('、')
}
